import React from "react";
import "./PageTopBar.scss";

const PageTopBar = (props) => {
  return <div className="page-topbar">{props.children}</div>;
};

export default PageTopBar;
